var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('step-progress',{attrs:{"donesteps":_vm._currentStep}}),_c(_vm._stepView,{tag:"component",on:{"stepdone":_vm._stepdone,"abbort":_vm._abbort}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }